import localStorage from './localStorage';
export default store => {
    store.subscribe((state) => {
        localStorage.set(store.state);
    });
}